export const PathAPI = {
  auth: {
    login: '/auth/login',
  },
  dailyJob: {
    list: '/daily-jobs',
    create: '/daily-jobs',
    detail: '/daily-jobs/:id',
    edit: '/daily-jobs/:id',
    submit: '/daily-jobs/:id',
  },
  job: {
    list: '/jobs',
  },
  notification: {
    list: '/notifications',
    /* No body. */
    readAll: '/notifications/read-all',
    /* POST registers a push token, DELETE removes it; both take { device_id },
       which is the FCM token. */
    device: '/notifications/device',
  },
  outlet: {
    dropdown: '/outlets/dropdown',
  },
  upload: {
    image: '/upload/image',
    /* Mirrors /upload/image: multipart, one file, returns the stored URL. */
    video: '/upload/video',
  },
};
